export function isAfterYear2023(): boolean {
    const today = new Date();
    return today.getUTCFullYear() > 2023;
}
